"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMeLazyQuery = exports.useMeQuery = exports.MeDocument = exports.useGetMyApiKeyLazyQuery = exports.useGetMyApiKeyQuery = exports.GetMyApiKeyDocument = exports.useUpdateProfileMutation = exports.UpdateProfileDocument = exports.useLogoutMutation = exports.LogoutDocument = exports.useForgotPasswordMutation = exports.ForgotPasswordDocument = exports.useChangeSubscriptionPlanMutation = exports.ChangeSubscriptionPlanDocument = exports.useChangePasswordMutation = exports.ChangePasswordDocument = exports.useRegisterMutation = exports.RegisterDocument = exports.useLoginMutation = exports.LoginDocument = exports.useFeedbackMutation = exports.FeedbackDocument = exports.useSectionsByCookbookIdLazyQuery = exports.useSectionsByCookbookIdQuery = exports.SectionsByCookbookIdDocument = exports.useGetSectionAndRecipeIdLazyQuery = exports.useGetSectionAndRecipeIdQuery = exports.GetSectionAndRecipeIdDocument = exports.useUpdateSectionPositionsMutation = exports.UpdateSectionPositionsDocument = exports.useRenameSectionMutation = exports.RenameSectionDocument = exports.useMoveSectionToCookbookMutation = exports.MoveSectionToCookbookDocument = exports.useDeleteSectionMutation = exports.DeleteSectionDocument = exports.useCreateSectionMutation = exports.CreateSectionDocument = exports.useAddRecipeToSectionMutation = exports.AddRecipeToSectionDocument = exports.useRecipesByCookbookAndSectionIdLazyQuery = exports.useRecipesByCookbookAndSectionIdQuery = exports.RecipesByCookbookAndSectionIdDocument = exports.useViewRecipeSearchLazyQuery = exports.useViewRecipeSearchQuery = exports.ViewRecipeSearchDocument = exports.useRecipeLinkSearchLazyQuery = exports.useRecipeLinkSearchQuery = exports.RecipeLinkSearchDocument = exports.useMenuPlannerRecipeSearchLazyQuery = exports.useMenuPlannerRecipeSearchQuery = exports.MenuPlannerRecipeSearchDocument = exports.useRandomRecipeLazyQuery = exports.useRandomRecipeQuery = exports.RandomRecipeDocument = exports.useGetSharedRecipeLazyQuery = exports.useGetSharedRecipeQuery = exports.GetSharedRecipeDocument = exports.useFindSectionsAndCookbookIdsForRecipeLazyQuery = exports.useFindSectionsAndCookbookIdsForRecipeQuery = exports.FindSectionsAndCookbookIdsForRecipeDocument = exports.useGetSectionAndCookbookIdForRecipeLazyQuery = exports.useGetSectionAndCookbookIdForRecipeQuery = exports.GetSectionAndCookbookIdForRecipeDocument = exports.useGetRecipeByIdWithCookbooksLazyQuery = exports.useGetRecipeByIdWithCookbooksQuery = exports.GetRecipeByIdWithCookbooksDocument = exports.useGetRecipeByIdLazyQuery = exports.useGetRecipeByIdQuery = exports.GetRecipeByIdDocument = exports.useUpdateRecipeNoteMutation = exports.UpdateRecipeNoteDocument = exports.useRemoveRecipeFromSectionMutation = exports.RemoveRecipeFromSectionDocument = exports.usePartialRecipeEditMutation = exports.PartialRecipeEditDocument = exports.useImportRecipeFromWebsiteMutation = exports.ImportRecipeFromWebsiteDocument = exports.useImportRecipeFromTextMutation = exports.ImportRecipeFromTextDocument = exports.useCloneRecipeMutation = exports.CloneRecipeDocument = exports.useBulkMoveRecipeSectionsMutation = exports.BulkMoveRecipeSectionsDocument = exports.useBulkImportPaprikaRecipesMutation = exports.BulkImportPaprikaRecipesDocument = exports.useBulkDeleteRecipesMutation = exports.BulkDeleteRecipesDocument = exports.useAddRecipeToAccountMutation = exports.AddRecipeToAccountDocument = exports.useUpdateRecipeMutation = exports.UpdateRecipeDocument = exports.useCreateRecipeMutation = exports.CreateRecipeDocument = exports.useChangeRecipePrivacyMutation = exports.ChangeRecipePrivacyDocument = exports.useMenuSectionsLazyQuery = exports.useMenuSectionsQuery = exports.MenuSectionsDocument = exports.useMenuPlannerLazyQuery = exports.useMenuPlannerQuery = exports.MenuPlannerDocument = exports.useUpdateMenuNoteMutation = exports.UpdateMenuNoteDocument = exports.useUpdateMenuItemMutation = exports.UpdateMenuItemDocument = exports.useSyncMenuSectionsMutation = exports.SyncMenuSectionsDocument = exports.useDeleteMenuNoteMutation = exports.DeleteMenuNoteDocument = exports.useDeleteMenuItemsMutation = exports.DeleteMenuItemsDocument = exports.useCreateMenuNoteMutation = exports.CreateMenuNoteDocument = exports.useCreateMenuItemsMutation = exports.CreateMenuItemsDocument = exports.useGroceryItemsLazyQuery = exports.useGroceryItemsQuery = exports.GroceryItemsDocument = exports.useCreateGroceryItemsFromRecipesMutation = exports.CreateGroceryItemsFromRecipesDocument = exports.useCompleteGroceryItemByKeywordMutation = exports.CompleteGroceryItemByKeywordDocument = exports.useChangeGroceryCategoryMutation = exports.ChangeGroceryCategoryDocument = exports.useAddRecipeLinkIngredientsToGroceryListMutation = exports.AddRecipeLinkIngredientsToGroceryListDocument = exports.useUpdateGroceryItemMutation = exports.UpdateGroceryItemDocument = exports.useDeleteGroceryItemsByRecipeMutation = exports.DeleteGroceryItemsByRecipeDocument = exports.useDeleteGroceryItemMutation = exports.DeleteGroceryItemDocument = exports.useDeleteCompletedGroceryItemsMutation = exports.DeleteCompletedGroceryItemsDocument = exports.useCreateGroceryItemsAndLinksMutation = exports.CreateGroceryItemsAndLinksDocument = exports.useClearGroceryListMutation = exports.ClearGroceryListDocument = exports.useUsersCookbookIsSharedWithLazyQuery = exports.useUsersCookbookIsSharedWithQuery = exports.UsersCookbookIsSharedWithDocument = exports.useSharedCookbookUsersLazyQuery = exports.useSharedCookbookUsersQuery = exports.SharedCookbookUsersDocument = exports.useGetSharedCookbookLazyQuery = exports.useGetSharedCookbookQuery = exports.GetSharedCookbookDocument = exports.useCookbooksLazyQuery = exports.useCookbooksQuery = exports.CookbooksDocument = exports.useUpdateSharedCookbookUserMutation = exports.UpdateSharedCookbookUserDocument = exports.useUpdateCookbookMutation = exports.UpdateCookbookDocument = exports.useRemoveCookbookFromCollectionMutation = exports.RemoveCookbookFromCollectionDocument = exports.useDeleteCookbookMutation = exports.DeleteCookbookDocument = exports.useCreateCookbookMutation = exports.CreateCookbookDocument = exports.useCopyCookbookToMeMutation = exports.CopyCookbookToMeDocument = exports.useAddCookbookToCollectionMutation = exports.AddCookbookToCollectionDocument = exports.useChangeCookbookPrivacyMutation = exports.ChangeCookbookPrivacyDocument = exports.useGetCookbooksLazyQuery = exports.useGetCookbooksQuery = exports.GetCookbooksDocument = exports.useGetIngredientListLazyQuery = exports.useGetIngredientListQuery = exports.GetIngredientListDocument = exports.useGetGroceryMapLazyQuery = exports.useGetGroceryMapQuery = exports.GetGroceryMapDocument = exports.useAllUsersLazyQuery = exports.useAllUsersQuery = exports.AllUsersDocument = exports.useLoginAsMutation = exports.LoginAsDocument = exports.useDeleteUserMutation = exports.DeleteUserDocument = exports.useCreateUserMutation = exports.CreateUserDocument = exports.useCreateLoginLinkMutation = exports.CreateLoginLinkDocument = exports.useCopyCookbookToMutation = exports.CopyCookbookToDocument = exports.useBulkImportRecipesMutation = exports.BulkImportRecipesDocument = exports.useUpdateIngredientListMutation = exports.UpdateIngredientListDocument = exports.useUpdateGroceryCategoryMapMutation = exports.UpdateGroceryCategoryMapDocument = exports.useParseSingleIngredientMutation = exports.ParseSingleIngredientDocument = exports.MeUserFragmentDoc = exports.SectionAndRecipeFragmentDoc = exports.RecipePreviewFragmentDoc = exports.AllRecipeLinkFragmentDoc = exports.AllIngredientHeaderFragmentDoc = exports.AllRegularIngredientsFragmentDoc = exports.SectionAndRecipeNameFragmentDoc = exports.RecipeNameFragmentDoc = exports.JustSectionFragmentDoc = exports.RecipeImportFragmentDoc = exports.RecipeCardFragmentDoc = exports.StandardMenuNoteFragmentDoc = exports.StandardMenuItemFragmentDoc = exports.MenuPlannerRecipeFragmentDoc = exports.GroceryListItemFragmentDoc = exports.GroceryRecipeInfoFragmentDoc = exports.GroceryCategoryInfoFragmentDoc = exports.JustCookbookFragmentDoc = exports.CookbookAccessLevel = void 0;
const client_1 = require("@apollo/client");
const Apollo = __importStar(require("@apollo/client"));
var CookbookAccessLevel;
(function (CookbookAccessLevel) {
    CookbookAccessLevel["CookbookOwner"] = "CookbookOwner";
    CookbookAccessLevel["Owner"] = "Owner";
    CookbookAccessLevel["Editor"] = "Editor";
    CookbookAccessLevel["Viewer"] = "Viewer";
})(CookbookAccessLevel = exports.CookbookAccessLevel || (exports.CookbookAccessLevel = {}));
exports.JustCookbookFragmentDoc = client_1.gql `
    fragment justCookbook on Cookbook {
  __typename
  id
  name
  privacy
  shareId
  owner
  position
  pictureUrl
  coverDetails {
    c1
    c2
    c3
    ac
    svgPatternKey
    coverStyleKey
    fontColor
    acOpacity
    bgColor
    bottomText
    fontFamily
  }
}
    `;
exports.GroceryCategoryInfoFragmentDoc = client_1.gql `
    fragment GroceryCategoryInfo on GroceryCategory {
  __typename
  id
  name
  position
}
    `;
exports.GroceryRecipeInfoFragmentDoc = client_1.gql `
    fragment GroceryRecipeInfo on Recipe {
  __typename
  id
  name
}
    `;
exports.GroceryListItemFragmentDoc = client_1.gql `
    fragment GroceryListItem on GroceryItem {
  __typename
  id
  name
  amount
  unit
  keyword
  createdAt
  complete
  recipeLinkId
  groceryCategoryId
  groceryCategoryName
  recipeId
  ingredientId
}
    `;
exports.MenuPlannerRecipeFragmentDoc = client_1.gql `
    fragment MenuPlannerRecipe on Recipe {
  __typename
  id
  name
  pictureUrl
  source
  rating
}
    `;
exports.StandardMenuItemFragmentDoc = client_1.gql `
    fragment StandardMenuItem on MenuItem {
  __typename
  id
  date
  recipe {
    ...MenuPlannerRecipe
  }
  scale
  menuSectionId
}
    ${exports.MenuPlannerRecipeFragmentDoc}`;
exports.StandardMenuNoteFragmentDoc = client_1.gql `
    fragment StandardMenuNote on MenuNote {
  __typename
  id
  date
  text
  menuSectionId
}
    `;
exports.RecipeCardFragmentDoc = client_1.gql `
    fragment RecipeCard on Recipe {
  __typename
  id
  name
  smallPictureUrl
  source
  createdAt
}
    `;
exports.RecipeImportFragmentDoc = client_1.gql `
    fragment RecipeImport on RecipeFormData {
  instructions
  times {
    type
    hr
    min
  }
  source
  otherImgs
  sourceUrl
  description
  name
  pictureUrl
  ingredients {
    ... on RegularIngredient {
      name
      unit
      amount
      keyword
    }
    ... on IngredientHeader {
      text
    }
    ... on RecipeLink {
      recipeId
      amount
      unit
      name
    }
  }
  youtubeVideoId
  servings
}
    `;
exports.JustSectionFragmentDoc = client_1.gql `
    fragment justSection on Section {
  __typename
  id
  name
  position
  owner
}
    `;
exports.RecipeNameFragmentDoc = client_1.gql `
    fragment recipeName on Recipe {
  __typename
  id
  name
  pictureUrl
  smallPictureUrl
  source
  rating
  createdAt
}
    `;
exports.SectionAndRecipeNameFragmentDoc = client_1.gql `
    fragment sectionAndRecipeName on Section {
  ...justSection
  recipes {
    ...recipeName
  }
}
    ${exports.JustSectionFragmentDoc}
${exports.RecipeNameFragmentDoc}`;
exports.AllRegularIngredientsFragmentDoc = client_1.gql `
    fragment AllRegularIngredients on RegularIngredient {
  __typename
  sid
  editedByUser
  name
  unit
  amount
  keyword
}
    `;
exports.AllIngredientHeaderFragmentDoc = client_1.gql `
    fragment AllIngredientHeader on IngredientHeader {
  __typename
  text
}
    `;
exports.AllRecipeLinkFragmentDoc = client_1.gql `
    fragment AllRecipeLink on RecipeLink {
  __typename
  recipeId
  amount
  unit
  name
}
    `;
exports.RecipePreviewFragmentDoc = client_1.gql `
    fragment RecipePreview on Recipe {
  __typename
  name
  pictureUrl
  smallPictureUrl
  description
  id
  notes
  ingredients {
    ... on RegularIngredient {
      ...AllRegularIngredients
    }
    ... on IngredientHeader {
      ...AllIngredientHeader
    }
    ... on RecipeLink {
      ...AllRecipeLink
    }
  }
  instructions
  times {
    __typename
    type
    value
  }
  youtubeVideoId
  source
  sourceUrl
  servings
  privacy
  shareId
  owner
  createdAt
  rating
}
    ${exports.AllRegularIngredientsFragmentDoc}
${exports.AllIngredientHeaderFragmentDoc}
${exports.AllRecipeLinkFragmentDoc}`;
exports.SectionAndRecipeFragmentDoc = client_1.gql `
    fragment sectionAndRecipe on Section {
  ...justSection
  recipes {
    ...RecipePreview
  }
}
    ${exports.JustSectionFragmentDoc}
${exports.RecipePreviewFragmentDoc}`;
exports.MeUserFragmentDoc = client_1.gql `
    fragment meUser on User {
  __typename
  id
  email
  firstName
  lastName
  numRecipes
  createdAt
  paddleCancelUrl
  paddleUpdateUrl
  role {
    type
    endDate
    recipeLimit
  }
}
    `;
exports.ParseSingleIngredientDocument = client_1.gql `
    mutation ParseSingleIngredient($ingredient: String!) {
  parseSingleIngredient(ingredient: $ingredient) {
    __typename
    name
    unit
    amount
    keyword
  }
}
    `;
function useParseSingleIngredientMutation(baseOptions) {
    return Apollo.useMutation(exports.ParseSingleIngredientDocument, baseOptions);
}
exports.useParseSingleIngredientMutation = useParseSingleIngredientMutation;
exports.UpdateGroceryCategoryMapDocument = client_1.gql `
    mutation UpdateGroceryCategoryMap($userId: String!, $newGroceryCategoryMap: String!) {
  updateGroceryCategoryMap(userId: $userId, newGroceryCategoryMap: $newGroceryCategoryMap)
}
    `;
function useUpdateGroceryCategoryMapMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateGroceryCategoryMapDocument, baseOptions);
}
exports.useUpdateGroceryCategoryMapMutation = useUpdateGroceryCategoryMapMutation;
exports.UpdateIngredientListDocument = client_1.gql `
    mutation UpdateIngredientList($newList: [String!]!) {
  updateIngredientList(newList: $newList)
}
    `;
function useUpdateIngredientListMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateIngredientListDocument, baseOptions);
}
exports.useUpdateIngredientListMutation = useUpdateIngredientListMutation;
exports.BulkImportRecipesDocument = client_1.gql `
    mutation BulkImportRecipes($urls: [String!]!, $owner: String!) {
  bulkImportRecipes(urls: $urls, owner: $owner) {
    ok
  }
}
    `;
function useBulkImportRecipesMutation(baseOptions) {
    return Apollo.useMutation(exports.BulkImportRecipesDocument, baseOptions);
}
exports.useBulkImportRecipesMutation = useBulkImportRecipesMutation;
exports.CopyCookbookToDocument = client_1.gql `
    mutation CopyCookbookTo($cookbookId: String!, $targetId: String!) {
  copyCookbookTo(cookbookId: $cookbookId, targetId: $targetId) {
    ok
  }
}
    `;
function useCopyCookbookToMutation(baseOptions) {
    return Apollo.useMutation(exports.CopyCookbookToDocument, baseOptions);
}
exports.useCopyCookbookToMutation = useCopyCookbookToMutation;
exports.CreateLoginLinkDocument = client_1.gql `
    mutation CreateLoginLink($email: String!, $changePasswordLink: Boolean!) {
  createLoginLink(email: $email, changePasswordLink: $changePasswordLink)
}
    `;
function useCreateLoginLinkMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateLoginLinkDocument, baseOptions);
}
exports.useCreateLoginLinkMutation = useCreateLoginLinkMutation;
exports.CreateUserDocument = client_1.gql `
    mutation CreateUser($input: RegisterInput!) {
  createUser(input: $input) {
    ok
  }
}
    `;
function useCreateUserMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateUserDocument, baseOptions);
}
exports.useCreateUserMutation = useCreateUserMutation;
exports.DeleteUserDocument = client_1.gql `
    mutation DeleteUser($userId: String!) {
  deleteUser(userId: $userId) {
    ok
  }
}
    `;
function useDeleteUserMutation(baseOptions) {
    return Apollo.useMutation(exports.DeleteUserDocument, baseOptions);
}
exports.useDeleteUserMutation = useDeleteUserMutation;
exports.LoginAsDocument = client_1.gql `
    mutation LoginAs($userId: String!) {
  loginAs(userId: $userId) {
    ok
  }
}
    `;
function useLoginAsMutation(baseOptions) {
    return Apollo.useMutation(exports.LoginAsDocument, baseOptions);
}
exports.useLoginAsMutation = useLoginAsMutation;
exports.AllUsersDocument = client_1.gql `
    query AllUsers($email: String!) {
  allUsers(email: $email) {
    id
    email
  }
}
    `;
function useAllUsersQuery(baseOptions) {
    return Apollo.useQuery(exports.AllUsersDocument, baseOptions);
}
exports.useAllUsersQuery = useAllUsersQuery;
function useAllUsersLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.AllUsersDocument, baseOptions);
}
exports.useAllUsersLazyQuery = useAllUsersLazyQuery;
exports.GetGroceryMapDocument = client_1.gql `
    query GetGroceryMap($userId: String!) {
  getGroceryMap(userId: $userId)
}
    `;
function useGetGroceryMapQuery(baseOptions) {
    return Apollo.useQuery(exports.GetGroceryMapDocument, baseOptions);
}
exports.useGetGroceryMapQuery = useGetGroceryMapQuery;
function useGetGroceryMapLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetGroceryMapDocument, baseOptions);
}
exports.useGetGroceryMapLazyQuery = useGetGroceryMapLazyQuery;
exports.GetIngredientListDocument = client_1.gql `
    query GetIngredientList {
  getIngredientList
}
    `;
function useGetIngredientListQuery(baseOptions) {
    return Apollo.useQuery(exports.GetIngredientListDocument, baseOptions);
}
exports.useGetIngredientListQuery = useGetIngredientListQuery;
function useGetIngredientListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetIngredientListDocument, baseOptions);
}
exports.useGetIngredientListLazyQuery = useGetIngredientListLazyQuery;
exports.GetCookbooksDocument = client_1.gql `
    query GetCookbooks($userId: String!) {
  getCookbooks(userId: $userId) {
    id
    name
  }
}
    `;
function useGetCookbooksQuery(baseOptions) {
    return Apollo.useQuery(exports.GetCookbooksDocument, baseOptions);
}
exports.useGetCookbooksQuery = useGetCookbooksQuery;
function useGetCookbooksLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetCookbooksDocument, baseOptions);
}
exports.useGetCookbooksLazyQuery = useGetCookbooksLazyQuery;
exports.ChangeCookbookPrivacyDocument = client_1.gql `
    mutation ChangeCookbookPrivacy($id: String!, $input: ChangeCookbookPrivacyInput!) {
  changeCookbookPrivacy(id: $id, input: $input) {
    __typename
    cookbook {
      __typename
      id
      privacy
      shareId
    }
  }
}
    `;
function useChangeCookbookPrivacyMutation(baseOptions) {
    return Apollo.useMutation(exports.ChangeCookbookPrivacyDocument, baseOptions);
}
exports.useChangeCookbookPrivacyMutation = useChangeCookbookPrivacyMutation;
exports.AddCookbookToCollectionDocument = client_1.gql `
    mutation AddCookbookToCollection($cookbookShareId: String!) {
  addCookbookToCollection(cookbookShareId: $cookbookShareId) {
    ok
  }
}
    `;
function useAddCookbookToCollectionMutation(baseOptions) {
    return Apollo.useMutation(exports.AddCookbookToCollectionDocument, baseOptions);
}
exports.useAddCookbookToCollectionMutation = useAddCookbookToCollectionMutation;
exports.CopyCookbookToMeDocument = client_1.gql `
    mutation CopyCookbookToMe($cookbookId: String!) {
  copyCookbookToMe(cookbookId: $cookbookId) {
    ok
  }
}
    `;
function useCopyCookbookToMeMutation(baseOptions) {
    return Apollo.useMutation(exports.CopyCookbookToMeDocument, baseOptions);
}
exports.useCopyCookbookToMeMutation = useCopyCookbookToMeMutation;
exports.CreateCookbookDocument = client_1.gql `
    mutation CreateCookbook($input: CookbookInput!) {
  createCookbook(input: $input) {
    __typename
    errors {
      path
      message
    }
    cookbook {
      ...justCookbook
    }
  }
}
    ${exports.JustCookbookFragmentDoc}`;
function useCreateCookbookMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateCookbookDocument, baseOptions);
}
exports.useCreateCookbookMutation = useCreateCookbookMutation;
exports.DeleteCookbookDocument = client_1.gql `
    mutation DeleteCookbook($id: String!) {
  deleteCookbook(id: $id) {
    __typename
    ok
  }
}
    `;
function useDeleteCookbookMutation(baseOptions) {
    return Apollo.useMutation(exports.DeleteCookbookDocument, baseOptions);
}
exports.useDeleteCookbookMutation = useDeleteCookbookMutation;
exports.RemoveCookbookFromCollectionDocument = client_1.gql `
    mutation RemoveCookbookFromCollection($cookbookId: String!) {
  removeCookbookFromCollection(cookbookId: $cookbookId) {
    ok
  }
}
    `;
function useRemoveCookbookFromCollectionMutation(baseOptions) {
    return Apollo.useMutation(exports.RemoveCookbookFromCollectionDocument, baseOptions);
}
exports.useRemoveCookbookFromCollectionMutation = useRemoveCookbookFromCollectionMutation;
exports.UpdateCookbookDocument = client_1.gql `
    mutation UpdateCookbook($id: String!, $cookbook: CookbookInput!) {
  updateCookbook(id: $id, cookbook: $cookbook) {
    __typename
    errors {
      path
      message
    }
    cookbook {
      ...justCookbook
    }
  }
}
    ${exports.JustCookbookFragmentDoc}`;
function useUpdateCookbookMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateCookbookDocument, baseOptions);
}
exports.useUpdateCookbookMutation = useUpdateCookbookMutation;
exports.UpdateSharedCookbookUserDocument = client_1.gql `
    mutation UpdateSharedCookbookUser($input: UpdateSharedCookbookUserInput!) {
  updateSharedCookbookUser(input: $input) {
    ok
  }
}
    `;
function useUpdateSharedCookbookUserMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateSharedCookbookUserDocument, baseOptions);
}
exports.useUpdateSharedCookbookUserMutation = useUpdateSharedCookbookUserMutation;
exports.CookbooksDocument = client_1.gql `
    query Cookbooks {
  cookbooks {
    ...justCookbook
    byName
    accessLevel
  }
}
    ${exports.JustCookbookFragmentDoc}`;
function useCookbooksQuery(baseOptions) {
    return Apollo.useQuery(exports.CookbooksDocument, baseOptions);
}
exports.useCookbooksQuery = useCookbooksQuery;
function useCookbooksLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.CookbooksDocument, baseOptions);
}
exports.useCookbooksLazyQuery = useCookbooksLazyQuery;
exports.GetSharedCookbookDocument = client_1.gql `
    query GetSharedCookbook($shareId: String!) {
  getSharedCookbook(shareId: $shareId) {
    ...justCookbook
    byName
    accessLevel
  }
}
    ${exports.JustCookbookFragmentDoc}`;
function useGetSharedCookbookQuery(baseOptions) {
    return Apollo.useQuery(exports.GetSharedCookbookDocument, baseOptions);
}
exports.useGetSharedCookbookQuery = useGetSharedCookbookQuery;
function useGetSharedCookbookLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetSharedCookbookDocument, baseOptions);
}
exports.useGetSharedCookbookLazyQuery = useGetSharedCookbookLazyQuery;
exports.SharedCookbookUsersDocument = client_1.gql `
    query SharedCookbookUsers($cookbookId: String!) {
  sharedCookbookUsers(cookbookId: $cookbookId) {
    users {
      accessLevel
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
function useSharedCookbookUsersQuery(baseOptions) {
    return Apollo.useQuery(exports.SharedCookbookUsersDocument, baseOptions);
}
exports.useSharedCookbookUsersQuery = useSharedCookbookUsersQuery;
function useSharedCookbookUsersLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.SharedCookbookUsersDocument, baseOptions);
}
exports.useSharedCookbookUsersLazyQuery = useSharedCookbookUsersLazyQuery;
exports.UsersCookbookIsSharedWithDocument = client_1.gql `
    query UsersCookbookIsSharedWith($cookbookId: String!) {
  usersCookbookIsSharedWith(cookbookId: $cookbookId) {
    users {
      id
      firstName
      lastName
    }
  }
}
    `;
function useUsersCookbookIsSharedWithQuery(baseOptions) {
    return Apollo.useQuery(exports.UsersCookbookIsSharedWithDocument, baseOptions);
}
exports.useUsersCookbookIsSharedWithQuery = useUsersCookbookIsSharedWithQuery;
function useUsersCookbookIsSharedWithLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.UsersCookbookIsSharedWithDocument, baseOptions);
}
exports.useUsersCookbookIsSharedWithLazyQuery = useUsersCookbookIsSharedWithLazyQuery;
exports.ClearGroceryListDocument = client_1.gql `
    mutation ClearGroceryList {
  clearGroceryList {
    ok
  }
}
    `;
function useClearGroceryListMutation(baseOptions) {
    return Apollo.useMutation(exports.ClearGroceryListDocument, baseOptions);
}
exports.useClearGroceryListMutation = useClearGroceryListMutation;
exports.CreateGroceryItemsAndLinksDocument = client_1.gql `
    mutation CreateGroceryItemsAndLinks($items: [GroceryItemStringInput!]!, $recipeId: String, $noName: Boolean) {
  createGroceryItemsAndLinks(items: $items, recipeId: $recipeId, noName: $noName) {
    __typename
    errors {
      path
      message
    }
    groceryItems {
      ...GroceryListItem
    }
  }
}
    ${exports.GroceryListItemFragmentDoc}`;
function useCreateGroceryItemsAndLinksMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateGroceryItemsAndLinksDocument, baseOptions);
}
exports.useCreateGroceryItemsAndLinksMutation = useCreateGroceryItemsAndLinksMutation;
exports.DeleteCompletedGroceryItemsDocument = client_1.gql `
    mutation DeleteCompletedGroceryItems {
  deleteCompletedGroceryItems {
    ok
  }
}
    `;
function useDeleteCompletedGroceryItemsMutation(baseOptions) {
    return Apollo.useMutation(exports.DeleteCompletedGroceryItemsDocument, baseOptions);
}
exports.useDeleteCompletedGroceryItemsMutation = useDeleteCompletedGroceryItemsMutation;
exports.DeleteGroceryItemDocument = client_1.gql `
    mutation DeleteGroceryItem($id: String!) {
  deleteGroceryItem(id: $id) {
    ok
  }
}
    `;
function useDeleteGroceryItemMutation(baseOptions) {
    return Apollo.useMutation(exports.DeleteGroceryItemDocument, baseOptions);
}
exports.useDeleteGroceryItemMutation = useDeleteGroceryItemMutation;
exports.DeleteGroceryItemsByRecipeDocument = client_1.gql `
    mutation DeleteGroceryItemsByRecipe($recipeId: String!) {
  deleteGroceryItemsByRecipe(recipeId: $recipeId) {
    __typename
    ok
  }
}
    `;
function useDeleteGroceryItemsByRecipeMutation(baseOptions) {
    return Apollo.useMutation(exports.DeleteGroceryItemsByRecipeDocument, baseOptions);
}
exports.useDeleteGroceryItemsByRecipeMutation = useDeleteGroceryItemsByRecipeMutation;
exports.UpdateGroceryItemDocument = client_1.gql `
    mutation UpdateGroceryItem($id: String!, $input: UpdateGroceryItemInput!, $rememberOptions: RememberOptions) {
  updateGroceryItem(id: $id, input: $input, rememberOptions: $rememberOptions) {
    __typename
    item {
      __typename
      id
      complete
      amount
      unit
      name
      keyword
      groceryCategoryName
    }
    recipe {
      id
      ingredients {
        ... on RegularIngredient {
          ...AllRegularIngredients
        }
        ... on IngredientHeader {
          ...AllIngredientHeader
        }
        ... on RecipeLink {
          ...AllRecipeLink
        }
      }
    }
  }
}
    ${exports.AllRegularIngredientsFragmentDoc}
${exports.AllIngredientHeaderFragmentDoc}
${exports.AllRecipeLinkFragmentDoc}`;
function useUpdateGroceryItemMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateGroceryItemDocument, baseOptions);
}
exports.useUpdateGroceryItemMutation = useUpdateGroceryItemMutation;
exports.AddRecipeLinkIngredientsToGroceryListDocument = client_1.gql `
    mutation AddRecipeLinkIngredientsToGroceryList($groceryItemId: String!, $recipeId: String!, $amount: String) {
  addRecipeLinkIngredientsToGroceryList(groceryItemId: $groceryItemId, recipeId: $recipeId, amount: $amount) {
    groceryItems {
      ...GroceryListItem
    }
    recipes {
      ...GroceryRecipeInfo
    }
  }
}
    ${exports.GroceryListItemFragmentDoc}
${exports.GroceryRecipeInfoFragmentDoc}`;
function useAddRecipeLinkIngredientsToGroceryListMutation(baseOptions) {
    return Apollo.useMutation(exports.AddRecipeLinkIngredientsToGroceryListDocument, baseOptions);
}
exports.useAddRecipeLinkIngredientsToGroceryListMutation = useAddRecipeLinkIngredientsToGroceryListMutation;
exports.ChangeGroceryCategoryDocument = client_1.gql `
    mutation changeGroceryCategory($id: String!, $keyword: String!, $groceryCategoryName: String!) {
  changeGroceryCategory(id: $id, groceryCategoryName: $groceryCategoryName, keyword: $keyword) {
    id
    groceryCategoryName
  }
}
    `;
function useChangeGroceryCategoryMutation(baseOptions) {
    return Apollo.useMutation(exports.ChangeGroceryCategoryDocument, baseOptions);
}
exports.useChangeGroceryCategoryMutation = useChangeGroceryCategoryMutation;
exports.CompleteGroceryItemByKeywordDocument = client_1.gql `
    mutation CompleteGroceryItemByKeyword($keyword: String!, $complete: Boolean!) {
  completeGroceryItemByKeyword(keyword: $keyword, complete: $complete) {
    ok
  }
}
    `;
function useCompleteGroceryItemByKeywordMutation(baseOptions) {
    return Apollo.useMutation(exports.CompleteGroceryItemByKeywordDocument, baseOptions);
}
exports.useCompleteGroceryItemByKeywordMutation = useCompleteGroceryItemByKeywordMutation;
exports.CreateGroceryItemsFromRecipesDocument = client_1.gql `
    mutation CreateGroceryItemsFromRecipes($input: CreateGroceryItemsFromRecipesInput!) {
  createGroceryItemsFromRecipes(input: $input) {
    groceryItems {
      ...GroceryListItem
    }
  }
}
    ${exports.GroceryListItemFragmentDoc}`;
function useCreateGroceryItemsFromRecipesMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateGroceryItemsFromRecipesDocument, baseOptions);
}
exports.useCreateGroceryItemsFromRecipesMutation = useCreateGroceryItemsFromRecipesMutation;
exports.GroceryItemsDocument = client_1.gql `
    query GroceryItems {
  groceryItems {
    items {
      ...GroceryListItem
    }
    recipes {
      ...GroceryRecipeInfo
    }
  }
}
    ${exports.GroceryListItemFragmentDoc}
${exports.GroceryRecipeInfoFragmentDoc}`;
function useGroceryItemsQuery(baseOptions) {
    return Apollo.useQuery(exports.GroceryItemsDocument, baseOptions);
}
exports.useGroceryItemsQuery = useGroceryItemsQuery;
function useGroceryItemsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GroceryItemsDocument, baseOptions);
}
exports.useGroceryItemsLazyQuery = useGroceryItemsLazyQuery;
exports.CreateMenuItemsDocument = client_1.gql `
    mutation CreateMenuItems($menuItems: [MenuItemInput!]!) {
  createMenuItems(menuItems: $menuItems) {
    ok
    errors {
      path
      message
    }
    menuItems {
      id
    }
  }
}
    `;
function useCreateMenuItemsMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateMenuItemsDocument, baseOptions);
}
exports.useCreateMenuItemsMutation = useCreateMenuItemsMutation;
exports.CreateMenuNoteDocument = client_1.gql `
    mutation CreateMenuNote($input: MenuNoteInput!) {
  createMenuNote(input: $input) {
    id
    text
    menuSectionId
    date
  }
}
    `;
function useCreateMenuNoteMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateMenuNoteDocument, baseOptions);
}
exports.useCreateMenuNoteMutation = useCreateMenuNoteMutation;
exports.DeleteMenuItemsDocument = client_1.gql `
    mutation DeleteMenuItems($ids: [String!]!) {
  deleteMenuItems(ids: $ids) {
    ok
  }
}
    `;
function useDeleteMenuItemsMutation(baseOptions) {
    return Apollo.useMutation(exports.DeleteMenuItemsDocument, baseOptions);
}
exports.useDeleteMenuItemsMutation = useDeleteMenuItemsMutation;
exports.DeleteMenuNoteDocument = client_1.gql `
    mutation DeleteMenuNote($id: String!) {
  deleteMenuNote(id: $id) {
    ok
  }
}
    `;
function useDeleteMenuNoteMutation(baseOptions) {
    return Apollo.useMutation(exports.DeleteMenuNoteDocument, baseOptions);
}
exports.useDeleteMenuNoteMutation = useDeleteMenuNoteMutation;
exports.SyncMenuSectionsDocument = client_1.gql `
    mutation SyncMenuSections($menuSections: [MenuSectionSyncInput!]!) {
  syncMenuSections(menuSections: $menuSections) {
    ok
    errors {
      path
      message
    }
    menuSections {
      id
      name
      position
    }
  }
}
    `;
function useSyncMenuSectionsMutation(baseOptions) {
    return Apollo.useMutation(exports.SyncMenuSectionsDocument, baseOptions);
}
exports.useSyncMenuSectionsMutation = useSyncMenuSectionsMutation;
exports.UpdateMenuItemDocument = client_1.gql `
    mutation UpdateMenuItem($menuItem: MenuItemUpdateInput!) {
  updateMenuItem(menuItem: $menuItem) {
    ok
  }
}
    `;
function useUpdateMenuItemMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateMenuItemDocument, baseOptions);
}
exports.useUpdateMenuItemMutation = useUpdateMenuItemMutation;
exports.UpdateMenuNoteDocument = client_1.gql `
    mutation UpdateMenuNote($id: String!, $input: UpdateMenuNoteInput!) {
  updateMenuNote(id: $id, input: $input) {
    ok
  }
}
    `;
function useUpdateMenuNoteMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateMenuNoteDocument, baseOptions);
}
exports.useUpdateMenuNoteMutation = useUpdateMenuNoteMutation;
exports.MenuPlannerDocument = client_1.gql `
    query MenuPlanner($startDate: String!, $endDate: String!) {
  menuPlanner(startDate: $startDate, endDate: $endDate) {
    ... on MenuItem {
      ...StandardMenuItem
    }
    ... on MenuNote {
      ...StandardMenuNote
    }
  }
}
    ${exports.StandardMenuItemFragmentDoc}
${exports.StandardMenuNoteFragmentDoc}`;
function useMenuPlannerQuery(baseOptions) {
    return Apollo.useQuery(exports.MenuPlannerDocument, baseOptions);
}
exports.useMenuPlannerQuery = useMenuPlannerQuery;
function useMenuPlannerLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.MenuPlannerDocument, baseOptions);
}
exports.useMenuPlannerLazyQuery = useMenuPlannerLazyQuery;
exports.MenuSectionsDocument = client_1.gql `
    query MenuSections {
  menuSections {
    id
    name
    position
  }
}
    `;
function useMenuSectionsQuery(baseOptions) {
    return Apollo.useQuery(exports.MenuSectionsDocument, baseOptions);
}
exports.useMenuSectionsQuery = useMenuSectionsQuery;
function useMenuSectionsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.MenuSectionsDocument, baseOptions);
}
exports.useMenuSectionsLazyQuery = useMenuSectionsLazyQuery;
exports.ChangeRecipePrivacyDocument = client_1.gql `
    mutation ChangeRecipePrivacy($id: String!, $unlisted: Boolean!) {
  changeRecipePrivacy(id: $id, unlisted: $unlisted) {
    __typename
    recipe {
      __typename
      id
      privacy
      shareId
    }
  }
}
    `;
function useChangeRecipePrivacyMutation(baseOptions) {
    return Apollo.useMutation(exports.ChangeRecipePrivacyDocument, baseOptions);
}
exports.useChangeRecipePrivacyMutation = useChangeRecipePrivacyMutation;
exports.CreateRecipeDocument = client_1.gql `
    mutation CreateRecipe($recipe: RecipeInput!) {
  createRecipe(recipe: $recipe) {
    __typename
    errors {
      path
      message
    }
    uploadUrl
    recipe {
      ...RecipePreview
    }
    user {
      ...meUser
    }
  }
}
    ${exports.RecipePreviewFragmentDoc}
${exports.MeUserFragmentDoc}`;
function useCreateRecipeMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateRecipeDocument, baseOptions);
}
exports.useCreateRecipeMutation = useCreateRecipeMutation;
exports.UpdateRecipeDocument = client_1.gql `
    mutation UpdateRecipe($id: String!, $recipe: RecipeInput!) {
  updateRecipe(id: $id, recipe: $recipe) {
    __typename
    errors {
      path
      message
    }
    uploadUrl
    recipe {
      ...RecipePreview
    }
  }
}
    ${exports.RecipePreviewFragmentDoc}`;
function useUpdateRecipeMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateRecipeDocument, baseOptions);
}
exports.useUpdateRecipeMutation = useUpdateRecipeMutation;
exports.AddRecipeToAccountDocument = client_1.gql `
    mutation AddRecipeToAccount($recipeId: String!, $sectionId: String) {
  addRecipeToAccount(recipeId: $recipeId, sectionId: $sectionId) {
    ok
  }
}
    `;
function useAddRecipeToAccountMutation(baseOptions) {
    return Apollo.useMutation(exports.AddRecipeToAccountDocument, baseOptions);
}
exports.useAddRecipeToAccountMutation = useAddRecipeToAccountMutation;
exports.BulkDeleteRecipesDocument = client_1.gql `
    mutation BulkDeleteRecipes($recipeIds: [String!]!) {
  bulkDeleteRecipes(recipeIds: $recipeIds) {
    __typename
    ok
    user {
      ...meUser
    }
  }
}
    ${exports.MeUserFragmentDoc}`;
function useBulkDeleteRecipesMutation(baseOptions) {
    return Apollo.useMutation(exports.BulkDeleteRecipesDocument, baseOptions);
}
exports.useBulkDeleteRecipesMutation = useBulkDeleteRecipesMutation;
exports.BulkImportPaprikaRecipesDocument = client_1.gql `
    mutation BulkImportPaprikaRecipes($input: BulkImportRecipesOptions!) {
  bulkImportPaprikaRecipes(input: $input) {
    ok
  }
}
    `;
function useBulkImportPaprikaRecipesMutation(baseOptions) {
    return Apollo.useMutation(exports.BulkImportPaprikaRecipesDocument, baseOptions);
}
exports.useBulkImportPaprikaRecipesMutation = useBulkImportPaprikaRecipesMutation;
exports.BulkMoveRecipeSectionsDocument = client_1.gql `
    mutation BulkMoveRecipeSections($options: BulkMoveRecipeOptions!) {
  bulkMoveRecipeSections(options: $options) {
    ok
  }
}
    `;
function useBulkMoveRecipeSectionsMutation(baseOptions) {
    return Apollo.useMutation(exports.BulkMoveRecipeSectionsDocument, baseOptions);
}
exports.useBulkMoveRecipeSectionsMutation = useBulkMoveRecipeSectionsMutation;
exports.CloneRecipeDocument = client_1.gql `
    mutation CloneRecipe($options: CloneRecipeInput!) {
  cloneRecipe(options: $options) {
    __typename
    ok
    recipe {
      ...RecipePreview
    }
    user {
      ...meUser
    }
  }
}
    ${exports.RecipePreviewFragmentDoc}
${exports.MeUserFragmentDoc}`;
function useCloneRecipeMutation(baseOptions) {
    return Apollo.useMutation(exports.CloneRecipeDocument, baseOptions);
}
exports.useCloneRecipeMutation = useCloneRecipeMutation;
exports.ImportRecipeFromTextDocument = client_1.gql `
    mutation ImportRecipeFromText($text: String!) {
  importRecipeFromText(text: $text) {
    ...RecipeImport
  }
}
    ${exports.RecipeImportFragmentDoc}`;
function useImportRecipeFromTextMutation(baseOptions) {
    return Apollo.useMutation(exports.ImportRecipeFromTextDocument, baseOptions);
}
exports.useImportRecipeFromTextMutation = useImportRecipeFromTextMutation;
exports.ImportRecipeFromWebsiteDocument = client_1.gql `
    mutation ImportRecipeFromWebsite($url: String!) {
  importRecipeFromWebsite(url: $url) {
    ...RecipeImport
  }
}
    ${exports.RecipeImportFragmentDoc}`;
function useImportRecipeFromWebsiteMutation(baseOptions) {
    return Apollo.useMutation(exports.ImportRecipeFromWebsiteDocument, baseOptions);
}
exports.useImportRecipeFromWebsiteMutation = useImportRecipeFromWebsiteMutation;
exports.PartialRecipeEditDocument = client_1.gql `
    mutation PartialRecipeEdit($id: String!, $input: PartialRecipe!) {
  partialRecipeEdit(id: $id, input: $input) {
    recipe {
      id
      rating
    }
  }
}
    `;
function usePartialRecipeEditMutation(baseOptions) {
    return Apollo.useMutation(exports.PartialRecipeEditDocument, baseOptions);
}
exports.usePartialRecipeEditMutation = usePartialRecipeEditMutation;
exports.RemoveRecipeFromSectionDocument = client_1.gql `
    mutation RemoveRecipeFromSection($options: RemoveRecipeFromSectionOptions!) {
  removeRecipeFromSection(options: $options) {
    ok
  }
}
    `;
function useRemoveRecipeFromSectionMutation(baseOptions) {
    return Apollo.useMutation(exports.RemoveRecipeFromSectionDocument, baseOptions);
}
exports.useRemoveRecipeFromSectionMutation = useRemoveRecipeFromSectionMutation;
exports.UpdateRecipeNoteDocument = client_1.gql `
    mutation UpdateRecipeNote($id: String!, $noteText: String!) {
  updateRecipeNote(id: $id, noteText: $noteText) {
    __typename
    recipe {
      id
      notes
    }
  }
}
    `;
function useUpdateRecipeNoteMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateRecipeNoteDocument, baseOptions);
}
exports.useUpdateRecipeNoteMutation = useUpdateRecipeNoteMutation;
exports.GetRecipeByIdDocument = client_1.gql `
    query GetRecipeById($id: String!) {
  getRecipeById(id: $id) {
    ...RecipePreview
  }
}
    ${exports.RecipePreviewFragmentDoc}`;
function useGetRecipeByIdQuery(baseOptions) {
    return Apollo.useQuery(exports.GetRecipeByIdDocument, baseOptions);
}
exports.useGetRecipeByIdQuery = useGetRecipeByIdQuery;
function useGetRecipeByIdLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetRecipeByIdDocument, baseOptions);
}
exports.useGetRecipeByIdLazyQuery = useGetRecipeByIdLazyQuery;
exports.GetRecipeByIdWithCookbooksDocument = client_1.gql `
    query GetRecipeByIdWithCookbooks($id: String!) {
  getRecipeById(id: $id) {
    cookbookSectionLookup {
      cookbook {
        id
        name
        accessLevel
      }
      section {
        id
        name
      }
    }
    ...RecipePreview
  }
}
    ${exports.RecipePreviewFragmentDoc}`;
function useGetRecipeByIdWithCookbooksQuery(baseOptions) {
    return Apollo.useQuery(exports.GetRecipeByIdWithCookbooksDocument, baseOptions);
}
exports.useGetRecipeByIdWithCookbooksQuery = useGetRecipeByIdWithCookbooksQuery;
function useGetRecipeByIdWithCookbooksLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetRecipeByIdWithCookbooksDocument, baseOptions);
}
exports.useGetRecipeByIdWithCookbooksLazyQuery = useGetRecipeByIdWithCookbooksLazyQuery;
exports.GetSectionAndCookbookIdForRecipeDocument = client_1.gql `
    query GetSectionAndCookbookIdForRecipe($recipeId: String!) {
  getSectionAndCookbookIdForRecipe(recipeId: $recipeId) {
    sectionId
    cookbookId
  }
}
    `;
function useGetSectionAndCookbookIdForRecipeQuery(baseOptions) {
    return Apollo.useQuery(exports.GetSectionAndCookbookIdForRecipeDocument, baseOptions);
}
exports.useGetSectionAndCookbookIdForRecipeQuery = useGetSectionAndCookbookIdForRecipeQuery;
function useGetSectionAndCookbookIdForRecipeLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetSectionAndCookbookIdForRecipeDocument, baseOptions);
}
exports.useGetSectionAndCookbookIdForRecipeLazyQuery = useGetSectionAndCookbookIdForRecipeLazyQuery;
exports.FindSectionsAndCookbookIdsForRecipeDocument = client_1.gql `
    query FindSectionsAndCookbookIdsForRecipe($recipeId: String!) {
  findSectionsAndCookbookIdsForRecipe(recipeId: $recipeId) {
    sectionId
    cookbookId
  }
}
    `;
function useFindSectionsAndCookbookIdsForRecipeQuery(baseOptions) {
    return Apollo.useQuery(exports.FindSectionsAndCookbookIdsForRecipeDocument, baseOptions);
}
exports.useFindSectionsAndCookbookIdsForRecipeQuery = useFindSectionsAndCookbookIdsForRecipeQuery;
function useFindSectionsAndCookbookIdsForRecipeLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.FindSectionsAndCookbookIdsForRecipeDocument, baseOptions);
}
exports.useFindSectionsAndCookbookIdsForRecipeLazyQuery = useFindSectionsAndCookbookIdsForRecipeLazyQuery;
exports.GetSharedRecipeDocument = client_1.gql `
    query GetSharedRecipe($shareId: String!) {
  getSharedRecipe(shareId: $shareId) {
    ...RecipePreview
  }
}
    ${exports.RecipePreviewFragmentDoc}`;
function useGetSharedRecipeQuery(baseOptions) {
    return Apollo.useQuery(exports.GetSharedRecipeDocument, baseOptions);
}
exports.useGetSharedRecipeQuery = useGetSharedRecipeQuery;
function useGetSharedRecipeLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetSharedRecipeDocument, baseOptions);
}
exports.useGetSharedRecipeLazyQuery = useGetSharedRecipeLazyQuery;
exports.RandomRecipeDocument = client_1.gql `
    query RandomRecipe {
  randomRecipe {
    ...RecipePreview
  }
}
    ${exports.RecipePreviewFragmentDoc}`;
function useRandomRecipeQuery(baseOptions) {
    return Apollo.useQuery(exports.RandomRecipeDocument, baseOptions);
}
exports.useRandomRecipeQuery = useRandomRecipeQuery;
function useRandomRecipeLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.RandomRecipeDocument, baseOptions);
}
exports.useRandomRecipeLazyQuery = useRandomRecipeLazyQuery;
exports.MenuPlannerRecipeSearchDocument = client_1.gql `
    query MenuPlannerRecipeSearch($searchQuery: String!, $offset: Int!, $recipesNotInCookbooks: Boolean) {
  recipeSearch(searchQuery: $searchQuery, offset: $offset, recipesNotInCookbooks: $recipesNotInCookbooks) @connection(key: "recipeSearch", filter: ["searchQuery"]) {
    __typename
    hasMoreRecipes
    recipes {
      ...MenuPlannerRecipe
    }
  }
}
    ${exports.MenuPlannerRecipeFragmentDoc}`;
function useMenuPlannerRecipeSearchQuery(baseOptions) {
    return Apollo.useQuery(exports.MenuPlannerRecipeSearchDocument, baseOptions);
}
exports.useMenuPlannerRecipeSearchQuery = useMenuPlannerRecipeSearchQuery;
function useMenuPlannerRecipeSearchLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.MenuPlannerRecipeSearchDocument, baseOptions);
}
exports.useMenuPlannerRecipeSearchLazyQuery = useMenuPlannerRecipeSearchLazyQuery;
exports.RecipeLinkSearchDocument = client_1.gql `
    query RecipeLinkSearch($searchQuery: String!, $offset: Int!, $recipesNotInCookbooks: Boolean) {
  recipeSearch(searchQuery: $searchQuery, offset: $offset, recipesNotInCookbooks: $recipesNotInCookbooks) @connection(key: "recipeSearch", filter: ["searchQuery"]) {
    __typename
    hasMoreRecipes
    recipes {
      ...recipeName
    }
  }
}
    ${exports.RecipeNameFragmentDoc}`;
function useRecipeLinkSearchQuery(baseOptions) {
    return Apollo.useQuery(exports.RecipeLinkSearchDocument, baseOptions);
}
exports.useRecipeLinkSearchQuery = useRecipeLinkSearchQuery;
function useRecipeLinkSearchLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.RecipeLinkSearchDocument, baseOptions);
}
exports.useRecipeLinkSearchLazyQuery = useRecipeLinkSearchLazyQuery;
exports.ViewRecipeSearchDocument = client_1.gql `
    query ViewRecipeSearch($searchQuery: String!, $offset: Int!, $recipesNotInCookbooks: Boolean) {
  recipeSearch(searchQuery: $searchQuery, offset: $offset, recipesNotInCookbooks: $recipesNotInCookbooks) @connection(key: "recipeSearch") {
    __typename
    hasMoreRecipes
    recipes {
      cookbookSectionLookup {
        cookbook {
          id
          name
          accessLevel
        }
        section {
          id
          name
        }
      }
      ...recipeName
    }
  }
}
    ${exports.RecipeNameFragmentDoc}`;
function useViewRecipeSearchQuery(baseOptions) {
    return Apollo.useQuery(exports.ViewRecipeSearchDocument, baseOptions);
}
exports.useViewRecipeSearchQuery = useViewRecipeSearchQuery;
function useViewRecipeSearchLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.ViewRecipeSearchDocument, baseOptions);
}
exports.useViewRecipeSearchLazyQuery = useViewRecipeSearchLazyQuery;
exports.RecipesByCookbookAndSectionIdDocument = client_1.gql `
    query RecipesByCookbookAndSectionId($sectionId: String!) {
  recipesByCookbookAndSectionId(sectionId: $sectionId) {
    ...recipeName
  }
}
    ${exports.RecipeNameFragmentDoc}`;
function useRecipesByCookbookAndSectionIdQuery(baseOptions) {
    return Apollo.useQuery(exports.RecipesByCookbookAndSectionIdDocument, baseOptions);
}
exports.useRecipesByCookbookAndSectionIdQuery = useRecipesByCookbookAndSectionIdQuery;
function useRecipesByCookbookAndSectionIdLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.RecipesByCookbookAndSectionIdDocument, baseOptions);
}
exports.useRecipesByCookbookAndSectionIdLazyQuery = useRecipesByCookbookAndSectionIdLazyQuery;
exports.AddRecipeToSectionDocument = client_1.gql `
    mutation AddRecipeToSection($recipeId: String!, $sectionId: String!) {
  addRecipeToSection(recipeId: $recipeId, sectionId: $sectionId) {
    __typename
    ok
  }
}
    `;
function useAddRecipeToSectionMutation(baseOptions) {
    return Apollo.useMutation(exports.AddRecipeToSectionDocument, baseOptions);
}
exports.useAddRecipeToSectionMutation = useAddRecipeToSectionMutation;
exports.CreateSectionDocument = client_1.gql `
    mutation CreateSection($input: CreateSectionInput!) {
  createSection(input: $input) {
    __typename
    errors {
      path
      message
    }
    section {
      ...justSection
    }
  }
}
    ${exports.JustSectionFragmentDoc}`;
function useCreateSectionMutation(baseOptions) {
    return Apollo.useMutation(exports.CreateSectionDocument, baseOptions);
}
exports.useCreateSectionMutation = useCreateSectionMutation;
exports.DeleteSectionDocument = client_1.gql `
    mutation DeleteSection($id: String!) {
  deleteSection(id: $id) {
    __typename
    ok
  }
}
    `;
function useDeleteSectionMutation(baseOptions) {
    return Apollo.useMutation(exports.DeleteSectionDocument, baseOptions);
}
exports.useDeleteSectionMutation = useDeleteSectionMutation;
exports.MoveSectionToCookbookDocument = client_1.gql `
    mutation MoveSectionToCookbook($input: MoveSectionToCookbook!) {
  moveSectionToCookbook(input: $input) {
    ok
  }
}
    `;
function useMoveSectionToCookbookMutation(baseOptions) {
    return Apollo.useMutation(exports.MoveSectionToCookbookDocument, baseOptions);
}
exports.useMoveSectionToCookbookMutation = useMoveSectionToCookbookMutation;
exports.RenameSectionDocument = client_1.gql `
    mutation RenameSection($id: String!, $name: String!) {
  renameSection(id: $id, name: $name) {
    __typename
    errors {
      path
      message
    }
    section {
      ...justSection
    }
  }
}
    ${exports.JustSectionFragmentDoc}`;
function useRenameSectionMutation(baseOptions) {
    return Apollo.useMutation(exports.RenameSectionDocument, baseOptions);
}
exports.useRenameSectionMutation = useRenameSectionMutation;
exports.UpdateSectionPositionsDocument = client_1.gql `
    mutation UpdateSectionPositions($ids: [String!]!) {
  updateSectionPositions(ids: $ids) {
    __typename
    ok
    sections {
      __typename
      id
      position
    }
  }
}
    `;
function useUpdateSectionPositionsMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateSectionPositionsDocument, baseOptions);
}
exports.useUpdateSectionPositionsMutation = useUpdateSectionPositionsMutation;
exports.GetSectionAndRecipeIdDocument = client_1.gql `
    query GetSectionAndRecipeId($cookbookId: String!) {
  getSectionAndRecipeId(cookbookId: $cookbookId) {
    sectionId
    recipeId
  }
}
    `;
function useGetSectionAndRecipeIdQuery(baseOptions) {
    return Apollo.useQuery(exports.GetSectionAndRecipeIdDocument, baseOptions);
}
exports.useGetSectionAndRecipeIdQuery = useGetSectionAndRecipeIdQuery;
function useGetSectionAndRecipeIdLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetSectionAndRecipeIdDocument, baseOptions);
}
exports.useGetSectionAndRecipeIdLazyQuery = useGetSectionAndRecipeIdLazyQuery;
exports.SectionsByCookbookIdDocument = client_1.gql `
    query SectionsByCookbookId($cookbookId: String!) {
  sectionsByCookbookId(cookbookId: $cookbookId) {
    ...justSection
  }
}
    ${exports.JustSectionFragmentDoc}`;
function useSectionsByCookbookIdQuery(baseOptions) {
    return Apollo.useQuery(exports.SectionsByCookbookIdDocument, baseOptions);
}
exports.useSectionsByCookbookIdQuery = useSectionsByCookbookIdQuery;
function useSectionsByCookbookIdLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.SectionsByCookbookIdDocument, baseOptions);
}
exports.useSectionsByCookbookIdLazyQuery = useSectionsByCookbookIdLazyQuery;
exports.FeedbackDocument = client_1.gql `
    mutation Feedback($text: String!) {
  feedback(text: $text) {
    ok
  }
}
    `;
function useFeedbackMutation(baseOptions) {
    return Apollo.useMutation(exports.FeedbackDocument, baseOptions);
}
exports.useFeedbackMutation = useFeedbackMutation;
exports.LoginDocument = client_1.gql `
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    __typename
    errors {
      path
      message
    }
    user {
      ...meUser
    }
  }
}
    ${exports.MeUserFragmentDoc}`;
function useLoginMutation(baseOptions) {
    return Apollo.useMutation(exports.LoginDocument, baseOptions);
}
exports.useLoginMutation = useLoginMutation;
exports.RegisterDocument = client_1.gql `
    mutation Register($input: RegisterInput!) {
  register(input: $input) {
    __typename
    errors {
      path
      message
    }
    user {
      ...meUser
    }
    cookbookId
    sectionId
  }
}
    ${exports.MeUserFragmentDoc}`;
function useRegisterMutation(baseOptions) {
    return Apollo.useMutation(exports.RegisterDocument, baseOptions);
}
exports.useRegisterMutation = useRegisterMutation;
exports.ChangePasswordDocument = client_1.gql `
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input) {
    __typename
    errors {
      path
      message
    }
    user {
      ...meUser
    }
  }
}
    ${exports.MeUserFragmentDoc}`;
function useChangePasswordMutation(baseOptions) {
    return Apollo.useMutation(exports.ChangePasswordDocument, baseOptions);
}
exports.useChangePasswordMutation = useChangePasswordMutation;
exports.ChangeSubscriptionPlanDocument = client_1.gql `
    mutation ChangeSubscriptionPlan($operation: String!, $yearly: Boolean!) {
  changeSubscriptionPlan(operation: $operation, yearly: $yearly) {
    user {
      ...meUser
    }
  }
}
    ${exports.MeUserFragmentDoc}`;
function useChangeSubscriptionPlanMutation(baseOptions) {
    return Apollo.useMutation(exports.ChangeSubscriptionPlanDocument, baseOptions);
}
exports.useChangeSubscriptionPlanMutation = useChangeSubscriptionPlanMutation;
exports.ForgotPasswordDocument = client_1.gql `
    mutation ForgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) {
    __typename
    ok
  }
}
    `;
function useForgotPasswordMutation(baseOptions) {
    return Apollo.useMutation(exports.ForgotPasswordDocument, baseOptions);
}
exports.useForgotPasswordMutation = useForgotPasswordMutation;
exports.LogoutDocument = client_1.gql `
    mutation Logout {
  logout {
    __typename
    ok
  }
}
    `;
function useLogoutMutation(baseOptions) {
    return Apollo.useMutation(exports.LogoutDocument, baseOptions);
}
exports.useLogoutMutation = useLogoutMutation;
exports.UpdateProfileDocument = client_1.gql `
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    ok
  }
}
    `;
function useUpdateProfileMutation(baseOptions) {
    return Apollo.useMutation(exports.UpdateProfileDocument, baseOptions);
}
exports.useUpdateProfileMutation = useUpdateProfileMutation;
exports.GetMyApiKeyDocument = client_1.gql `
    query GetMyApiKey {
  getMyApiKey
}
    `;
function useGetMyApiKeyQuery(baseOptions) {
    return Apollo.useQuery(exports.GetMyApiKeyDocument, baseOptions);
}
exports.useGetMyApiKeyQuery = useGetMyApiKeyQuery;
function useGetMyApiKeyLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.GetMyApiKeyDocument, baseOptions);
}
exports.useGetMyApiKeyLazyQuery = useGetMyApiKeyLazyQuery;
exports.MeDocument = client_1.gql `
    query Me {
  me {
    __typename
    user {
      ...meUser
    }
  }
}
    ${exports.MeUserFragmentDoc}`;
function useMeQuery(baseOptions) {
    return Apollo.useQuery(exports.MeDocument, baseOptions);
}
exports.useMeQuery = useMeQuery;
function useMeLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(exports.MeDocument, baseOptions);
}
exports.useMeLazyQuery = useMeLazyQuery;
//# sourceMappingURL=apolloComponents.js.map